import { t } from 'element-ui/src/locale';

export default {
  methods: {
    t(...args) {
      return t.apply(this, args);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/element/src/mixins/locale.js